module.exports = __webpack_public_path__ + "static/media/4.37507c46.jpg";